import { FunctionComponent } from "react";

import { Link } from "@bps/fluent-ui";
import { useTenantQuery } from "@libs/api/gateways/plt/plt-gateway.hooks";

interface TenantLinkProps {
  tenantId: string;
}
export const TenantLink: FunctionComponent<TenantLinkProps> = ({
  tenantId
}) => {
  const { data } = useTenantQuery(tenantId);
  return (
    <Link href={`/tenants/${tenantId}`} target="_blank">
      {data?.name}
    </Link>
  );
};
